export default __webpack_public_path__ + "static/media/bocweb.0ca28579.png";